export const FIND_TAG_FAILURE = 'FIND_TAG_FAILURE';

export const findTagFailure = (payload: Error) => ({
    type: FIND_TAG_FAILURE,
    payload,
    error: true,
});
